import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { usd } from '@/lib/billingApi';

const Tile = ({ label, value, tone = 'text-slate-800', bg = 'bg-white', testId, big }) => (
  <Card className={`${bg} border-slate-200 shadow-none`}>
    <CardContent className="p-4">
      <div className="text-[11px] uppercase tracking-wider font-bold text-slate-500 mb-1">{label}</div>
      <div className={`${big ? 'text-2xl font-black' : 'text-xl font-bold'} ${tone} tabular-nums`} data-testid={testId}>{value}</div>
    </CardContent>
  </Card>
);

export const KpiTiles = ({ s }) => {
  const v = (x, f = (y) => y) => (s ? f(x ?? 0) : '—');
  const warn = (n) => (n ? 'text-red-600' : 'text-slate-800');
  return (
    <div className="space-y-3" data-testid="sales-kpis">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Tile big label="Net revenue" value={v(s?.net_revenue, usd)} tone="text-green-700" bg="bg-green-50" testId="tile-total-revenue" />
        <Tile big label="MRR" value={v(s?.mrr, usd)} tone="text-[#00247D]" bg="bg-blue-50" testId="tile-mrr" />
        <Tile big label="ARR" value={v(s?.arr, usd)} tone="text-[#00247D]" bg="bg-blue-50" testId="tile-arr" />
        <Tile big label="Active subscriptions" value={v(s?.active_subscriptions)} tone="text-amber-700" bg="bg-amber-50" testId="tile-active" />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Tile label="Renewals next 30 days" value={v(s?.upcoming_renewals_30d)} testId="tile-upcoming" />
        <Tile label="Auto-renew off" value={v(s?.cancelled_auto_renew)} testId="tile-auto-renew-off" />
        <Tile label="Past due" value={v(s?.past_due)} tone={warn(s?.past_due)} testId="tile-past-due" />
        <Tile label="Needs review" value={v(s?.needs_review)} tone={warn(s?.needs_review)} testId="tile-needs-review" />
      </div>
      {s && (s.test_revenue > 0 || s.test_active_subscriptions > 0) && (
        <p className="text-xs rounded-lg border border-amber-300 bg-amber-50 text-amber-900 px-3 py-2" data-testid="sales-test-summary">
          <b>Test mode:</b> {usd(s.test_revenue)} simulated revenue · {s.test_active_subscriptions} simulated subscriptions ({usd(s.test_mrr)} MRR). Excluded from Net revenue, MRR, ARR and Active subscriptions; the renewal and review counts include them.
        </p>
      )}
      {s?.receipts_failing > 0 && (
        <p className="text-xs rounded-lg border border-red-200 bg-red-50 text-red-800 px-3 py-2" data-testid="sales-receipts-failing">
          {s.receipts_failing} receipt email{s.receipts_failing === 1 ? ' is' : 's are'} failing to send. Open the transaction to resend.
        </p>
      )}
    </div>
  );
};
